/* eslint-disable tailwindcss/no-arbitrary-value -- Sizes & colors from the new design system are not included in the project yet */
'use client';
import React, { useRef, useEffect, useState } from 'react';

interface Props {
  price: number;
  onChange: (val: number) => void;
  label: string;
  priceSymbol?: string;
  values: number[];
}

const CIPriceSlider: React.FC<Props> = ({
  price,
  onChange,
  label,
  priceSymbol = '₱',
  values,
}) => {
  const priceRef = useRef<HTMLDivElement>(null);
  const [priceWidth, setPriceWidth] = useState(0);
  const value = values.findIndex((item) => item === price);
  const min = 0;
  const max = values.length - 1;

  useEffect(() => {
    if (priceRef.current && priceRef.current.offsetWidth !== priceWidth) {
      setPriceWidth(priceRef.current.offsetWidth);
    }
  }, [value, priceWidth]);

  const handleChange: React.FormEventHandler<HTMLInputElement> = (e) => {
    onChange(values[e.currentTarget.valueAsNumber]);
  };
  const trackWidth = ((value - min) / (max - min)) * 100;

  const pricePosition =
    trackWidth >= 10 && trackWidth <= 90
      ? `calc(${trackWidth}% - ${priceWidth / 2}px)`
      : trackWidth > 90
        ? `calc(100% - ${priceWidth}px)`
        : 0;

  return (
    <div className="flex flex-col gap-2.5 w-full">
      {label && (
        <p className="text-gray-900 text-lg leading-6 font-semibold">{label}</p>
      )}
      <div className="relative h-4 w-full mb-6">
        <div className="absolute inset-0 top-1 h-1.5 overflow-hidden rounded-full bg-gray-300">
          <div
            className="h-full bg-[#04709B]"
            style={{ width: `${trackWidth}%` }}
          />
        </div>
        <input
          type="range"
          min={0}
          max={values.length - 1}
          value={value}
          onInput={handleChange}
          className="form-range absolute rounded-full h-4 inset-0 appearance-none bg-transparent outline-none [&::-moz-range-thumb]:bg-primary-800 [&::-webkit-slider-thumb]:bg-primary-800 [&::-moz-range-thumb]:size-4 [&::-webkit-slider-thumb]:size-4"
        />
        <div
          ref={priceRef}
          className="text-gray-900 text-base font-medium absolute -bottom-6 pointer-events-none"
          style={{ left: pricePosition }}
        >
          {priceSymbol}
          {price}
        </div>
      </div>
    </div>
  );
};

export { CIPriceSlider };
